module.exports = __webpack_public_path__ + "static/media/bg1.b9863b07.svg";